import HeroCard from "../Components/HeroCard";
import FeaturedWork from "../Components/FeaturedWork";
import {Link} from "react-router-dom";
import Plasma from "../Components/Plasma";
import React from "react";


export default function Home() {

    return (
        <div id="background" className="bg-stone-300 min-h-screen w-full p-2 lg:p-6">
            <div id="full" className="bg-stone-50 p-3 lg:p-10 rounded-lg w-full shadow-md max-w-6xl mx-auto">
                <HeroCard />
                <div className="flex justify-around flex-wrap mt-6">
                    <Link to="/Projects" className="cta-button">
                        <button>Browse projects</button>
                    </Link>
                    <Link to="/About" className="cta-button">
                        <button >Who's Lander?</button>
                    </Link>
                    <Link to="/Contact" className="cta-button">
                        <button >Contact me</button>
                    </Link>

                </div>
                <h2 className="text-2xl sm:text-3xl font-bold text-center mt-10 mb-2">
                    Currently working on
                </h2>

                <button onClick={() => window.open("https://habittracker-65b10.web.app/login", "_blank")} className="relative w-full h-24 overflow-hidden rounded-xl bg-black hover:-translate-y-2 hover:cursor-pointer hover:shadow-2xl transition-all duration-200">
                    <Plasma
                        color="#9B30FF"
                        speed={0.6}
                        scale={1.1}
                        opacity={0.8}
                        rotation={90} // new prop
                        mouseInteractive={false}
                    />
                    <div className="relative z-10 flex items-center justify-center h-full text-white text-2xl font-bold hover:text-3xl hover:text-purple-400 transition-all duration-200">
                        Habit Tracker
                    </div>
                </button>


                <FeaturedWork/>
            </div>
        </div>
    );
}
